import { render, staticRenderFns } from "./EditRecipient.vue?vue&type=template&id=7c8a1c52&scoped=true&"
import script from "./EditRecipient.vue?vue&type=script&lang=js&"
export * from "./EditRecipient.vue?vue&type=script&lang=js&"
import style0 from "./EditRecipient.vue?vue&type=style&index=0&id=7c8a1c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8a1c52",
  null
  
)

component.options.__file = "EditRecipient.vue"
export default component.exports